// test1783
(1783 && 0);
